import React, { useState, useEffect } from 'react';
import { 
  Video, 
  UserCheck, 
  Compass, 
  BookOpen, 
  History, 
  Users 
} from 'lucide-react';
import AboutUsHeroForm from './AboutUsHeroForm';
import AboutUsPrincipalForm from './AboutUsPrincipalForm';
import AboutUsVisionMissionValuesForm from './AboutUsVisionMissionValuesForm';
import AboutUsPhilosophyForm from './AboutUsPhilosophyForm';
import AboutUsHistoryForm from './AboutUsHistoryForm';
import AboutUsLeadershipForm from './AboutUsLeadershipForm';
import './FormsUnified.css';

export default function AboutUsForm({ apiBase, activeTab }) {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    if (activeTab === 'cms-about-hero' || activeTab === 'hero') {
      setCurrentSection('hero');
    } else if (activeTab === 'cms-about-principal' || activeTab === 'principal') {
      setCurrentSection('principal');
    } else if (activeTab === 'cms-about-values' || activeTab === 'values') {
      setCurrentSection('values');
    } else if (activeTab === 'cms-about-philosophy' || activeTab === 'philosophy') {
      setCurrentSection('philosophy');
    } else if (activeTab === 'cms-about-history' || activeTab === 'history') {
      setCurrentSection('history');
    } else if (activeTab === 'cms-about-leadership' || activeTab === 'leadership') {
      setCurrentSection('leadership');
    }
  }, [activeTab]);

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'hero' ? 'active' : ''}`}
          onClick={() => setCurrentSection('hero')}
        >
          <Video className="w-4 h-4 mr-2" />
          <span>Hero Banner</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'principal' ? 'active' : ''}`}
          onClick={() => setCurrentSection('principal')}
        >
          <UserCheck className="w-4 h-4 mr-2" />
          <span>Principal Message</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'values' ? 'active' : ''}`}
          onClick={() => setCurrentSection('values')}
        >
          <Compass className="w-4 h-4 mr-2" />
          <span>Vision & Values</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'philosophy' ? 'active' : ''}`}
          onClick={() => setCurrentSection('philosophy')}
        >
          <BookOpen className="w-4 h-4 mr-2" />
          <span>Philosophy & Motto</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'history' ? 'active' : ''}`}
          onClick={() => setCurrentSection('history')}
        >
          <History className="w-4 h-4 mr-2" />
          <span>History & Timeline</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'leadership' ? 'active' : ''}`}
          onClick={() => setCurrentSection('leadership')}
        >
          <Users className="w-4 h-4 mr-2" />
          <span>Leadership Team</span>
        </button>
      </div>

      {/* Render Active Section Form */}
      <div className="unified-tab-content">
        {currentSection === 'hero' && <AboutUsHeroForm apiBase={apiBase} />}
        {currentSection === 'principal' && <AboutUsPrincipalForm apiBase={apiBase} />}
        {currentSection === 'values' && <AboutUsVisionMissionValuesForm apiBase={apiBase} />}
        {currentSection === 'philosophy' && <AboutUsPhilosophyForm apiBase={apiBase} />}
        {currentSection === 'history' && <AboutUsHistoryForm apiBase={apiBase} />}
        {currentSection === 'leadership' && <AboutUsLeadershipForm apiBase={apiBase} />}
      </div>
    </div>
  );
}
